import { extractOnlyNumbers, removeMultipleSpace, removeSpecialCharAndNumFn1, removeUnderScrSpaceBet, removeUnderScrSpCharSpaceBet, replaceMultipleSpaces, safeToString, safeTrim, sliceText } from "../../../utils/common";


export const OWNERSHIP_INITIAL_STATE = {
  // BASICINFORMATION: [
  name: "",
  phone: "",
  email: "",
  designation: "",
  pan: "",
  identity_no: ""
}
export const OWNERSHIP_FORM_FIELDS = {
  // BASICINFORMATION: [
  name: {
    name: "name",
    inputType: "inputField",
    component: "InputField",
    label: "Owner Name",
    fullWidth: true,
    required: true,
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeToString(removeSpecialCharAndNumFn1(value))), 150)
        return value;
      },
    },
  },
  phone: {
    name: "phone",
    inputType: "inputField",
    component: "InputField",
    label: "Phone",
    fullWidth: true,
    placeholder: "Type Here...",
    required: true,

    type: "tel",
    customOptions: {
      formatValueFn: (value) => {
        return sliceText(extractOnlyNumbers(value), 10);
      },
    },
  },
  email: {
    name: "email",
    inputType: "inputField",
    component: "InputField",
    label: "Email",
    fullWidth: true,
    placeholder: "Type Here...",
    type: "text",
    required: true,

    customOptions: {

      formatValueFn: (value) => {
        return sliceText(removeUnderScrSpaceBet(value.toLowerCase()), 150);

      },
    }
  },
  designation: {
    name: "designation",
    inputType: "text",
    component: "SelectField",
    label: "Designation",
    fullWidth: true,
    placeholder: "Select Here...",
    customOptions: {

      formatValueFn: (value) => {
        value = sliceText(replaceMultipleSpaces(value), 50);
        return value;
      }

    }
  },
  identity_no: {
    name: "identity_no",
    inputType: "inputField",
    component: "InputField",
    label: "Identity No",
    fullWidth: true,
    placeholder: "Type Here...",
    customOptions: {

      formatValueFn: (value) => {
        value = sliceText(safeTrim(value), 50);
        return value;
      }

    }
  },
  pan: {
    name: "pan",
    inputType: "inputField",
    component: "InputField",
    label: "PAN",
    fullWidth: true,
    placeholder: "Type Here...",
    customOptions: {

      formatValueFn: (value) => {
        value = sliceText(removeUnderScrSpCharSpaceBet(value), 10);
        return value.toUpperCase();
      }

    }
  }
  // ],
};



export const OWNERSHIP_API = {
  OWNERSHIP_CREATE: { url: "/organization/create-ownership", method: "POST" },
  OWNERSHIP_UPDATE: { url: "/organization/modify-ownership/", method: "POST" },
  OWNERSHIP_DELETE: { url: "/organization/org-bank/", method: "DELETE" },
  OWNERSHIP_LIST: { url: "/organization/get-ownership/", method: "GET" },
  MASTER_OWNERSHIP_LIST: {
    url: "/organization/org-bank/admin/master",
    method: "GET",
  },
};

export const OWNERSHIP_TABLE_HEADER = [
  { key: "slNo", label: "SL No.", isShortable: true, isVisible: true },
  // { key: "ecode", label: "Employee Code", isClickable: true, isShortable: true, isVisible: true },
  {
    key: "name",
    label: "Owner Name",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    isClickable: true,
    defaultValue: "N/A"


  },
  {
    key: "designation",
    label: "Designation",
    isShortable: true,
    isVisible: true,
    isColumnSticky: "true",
    defaultValue: "N/A"
  },
  {
    key: "email",
    label: "Email",
    align: "left",
    isShortable: false,
    isVisible: false,
  },
  {
    key: "phone",
    label: "Phone",
    align: "left",
    isShortable: false,
    isVisible: true,
    defaultValue: "N/A"

  },
  {
    key: "pan",
    label: "PAN",
    align: "left",
    isShortable: false,
    isVisible: false,
    defaultValue: "N/A"

  },
  {
    key: "identity_no",
    label: "Identity No",
    align: "left",
    isShortable: false,
    isVisible: false,
    defaultValue: "N/A"

  },
];